import PropTypes from 'prop-types'

import LinkButton from '../ui/LinkButton'
import styles from './DetallePie.module.css'

const DetallePie = ({ idPublicacion, setReclamo, esVentas }) => {
  return (
    <div className={styles.detallePie}>
      {!esVentas && idPublicacion !== null && (
        <LinkButton className={styles.btnSuccess} to={`/Publicacion/${idPublicacion}`}>
          Volver a Comprar
        </LinkButton>
      )}
      <button type="button" className={styles.btnDanger} onClick={() => setReclamo(true)}>
        Reclamar!
      </button>
    </div>
  )
}

export default DetallePie

DetallePie.propTypes = {
  idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setReclamo: PropTypes.func.isRequired,
  esVentas: PropTypes.bool
}
